import React from 'react';

import { Box, Text, SimpleGrid } from '@chakra-ui/react';

import { useColors } from './colors';

export const DetailField = ({ label, value, mono = false }) => {
  const { subTextColor, textColor } = useColors();
  return (
    <Box>
      <Text fontSize="xs" color={subTextColor} mb={0.5}>
        {label}
      </Text>
      <Text
        fontSize="sm"
        color={textColor}
        fontWeight="medium"
        fontFamily={mono ? 'mono' : 'inherit'}
        wordBreak="break-word"
      >
        {value ?? '—'}
      </Text>
    </Box>
  );
};

export const DetailSection = ({ title, children, columns = 2 }) => {
  const { headingColor, cardBg, borderColor } = useColors();
  return (
    <Box
      bg={cardBg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="lg"
      p={5}
    >
      <Text fontWeight="semibold" color={headingColor} fontSize="md" mb={4}>
        {title}
      </Text>
      <SimpleGrid columns={{ base: 1, md: columns }} spacing={4}>
        {children}
      </SimpleGrid>
    </Box>
  );
};
